export default __webpack_public_path__ + "static/AdobeInDesign-9a6604bb07477be3ef2371e6e431238f.png";